/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define(['endpoints', 'rest/request/singleRequestServiceFactory', 'rest/request/batchRequestServiceFactory',
    'apiKeyNames'],
function(endpoints, singleRequestServiceFactory, batchRequestServiceFactory, ApiKeyNames) {
    'use strict';

    return {
        structuredGeocode: singleRequestServiceFactory(endpoints.structuredGeocode, ApiKeyNames.search),
        batch: batchRequestServiceFactory(100, {
            single: endpoints.batchSearchQuery, batch: endpoints.batchSearch, batchSync: endpoints.batchSyncSearch
        }, ApiKeyNames.search)
    };
}
);



// WEBPACK FOOTER //
// ./rest/structuredGeocode.js